module.exports = __webpack_public_path__ + "media/images/number_10-1de7b587bf202ed51463b77728b61e70.png";